import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Tooltip from "@material-ui/core/Tooltip";
import Fade from "@material-ui/core/Fade";
import merge from "lodash/merge";
import ReactGA from "react-ga";
//import commonCrust from "../data/commonCrust.json";
//import Commoncrust3d from "./CommonCrust3D";
import ccWhite from "../images/cc_white.jpg";
import ccDkGrey from "../images/cc_dkGray.jpg";
import ccLtGrey from "../images/cc_ltGray.jpg";
import ccRed from "../images/cc_red.jpg";
import ccBlue from "../images/cc_blue.jpg";
import ccOlive from "../images/cc_olive.jpg";
import ccBeige from "../images/cc_beige.jpg";
import ccBrown from "../images/cc_brown.jpg";
import ccBurgundy from "../images/cc_burgundy.jpg";
import ccTan from "../images/cc_tan.jpg";
import ccGreen from "../images/cc_green.jpg";
import ccPurple from "../images/cc_purple.jpg";

import {
  downloadIcon,
  closeModalIcon,
  starOutlineIcon,
  starSolidIcon,
} from "./Icons";
import "../App.css";

//import ReactGA from "react-ga";

function DialogModal({
  popup,
  handleClose,
  store,
  handleStore,
  selected,
  startDownload,
  colorAttributeFound,
  handleClick,
  similarColorThumb,
  setSettingDialog,
  width,
  height,
  enableToolTip,
}) {
  const [showFamily, setShowFamily] = useState(true);
  const [filtered, setFiltered] = useState([]);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [dismissMessage, setDismissMessage] = useState(false);
  const [viewCrust, setViewCrust] = useState(false);
  const targetRef = useRef(null);

  const showTip = enableToolTip;

  const trayWidth = width >= 1280 ? 600 : 300;
  const trayHeight = height >= 600 ? 450 : 300;

  // useEffect(() => {
  //   if (selected.csi_name !== undefined) {
  //     ReactGA.pageview(
  //       window.location.pathname + `/${selected.csi_code}-${selected.csi_name}`
  //     );
  //   }
  // }, [selected]);

  useLayoutEffect(() => {
    const getColumns = trayWidth / similarColorThumb; // 12
    const getRows = colorAttributeFound.length - 1; // 37
    const getHeight = getRows / getColumns;
    const getSize = Math.ceil(getHeight) * similarColorThumb;
    if (getSize >= 150 && showTip) {
      setDismissMessage(false);
    }
    setDimensions({
      width: trayWidth,
      height: getSize,
    });
    // eslint-disable-next-line
  }, [colorAttributeFound]);

  const handleDismissMessage = () => {
    setDismissMessage(true);
  };
  const handleSettings = () => {
    setSettingDialog(true);
  };
  const handleDownload = (size, swatch) => {
    ReactGA.event({
      category: "download",
      action: `${swatch.csi_code}-${swatch.csi_name}`,
      label: size,
    });
    startDownload(size, swatch);
  };

  function getCrust(color) {
    switch (color) {
      case "DK GREY":
        return ccDkGrey;
      case "LT GREY":
        return ccLtGrey;
      case "WHITE":
        return ccWhite;
      case "BLUE":
        return ccBlue;
      case "RED":
        return ccRed;
      case "BURGUNDY":
        return ccBurgundy;
      case "BROWN":
        return ccBrown;
      case "TAN":
        return ccTan;
      case "OLIVE":
        return ccOlive;
      case "BEIGE":
        return ccBeige;
      case "GREEN":
        return ccGreen;
      case "PURPLE":
        return ccPurple;
      default:
        return null;
    }
  }

  // function to define the value of the swatch to all other swatches.
  // The lower the number the more accurate
  function getDiff(a, x) {
    if (x) {
      const getSum = x
        .map((item, i) => Math.abs(item - a.colorAtt[i]))
        .reduce((a, b) => a + b, 0);
      return getSum;
    }
    return null;
  }

  // const RGBToHSB = (r, g, b) => {
  //   r /= 255;
  //   g /= 255;
  //   b /= 255;
  //   const v = Math.max(r, g, b),
  //     n = v - Math.min(r, g, b);
  //   const h =
  //     n === 0
  //       ? 0
  //       : n && v === r
  //       ? (g - b) / n
  //       : v === g
  //       ? 2 + (b - r) / n
  //       : 4 + (r - g) / n;
  //   return [60 * (h < 0 ? h + 6 : h), v && (n / v) * 100, v * 100];
  // };

  useEffect(() => {
    if (popup && colorAttributeFound.length >= 2 && selected) {
      const filterRange = colorAttributeFound.map((item) =>
        getDiff(item[0], selected.colorAtt)
      );
      const csiScore = colorAttributeFound.map((item, i) =>
        merge(
          [
            {
              hex: item[0].hex,
              csi_code: item[0].csi_code,
              csi_name: item[0].csi_name,
            },
          ],
          [{ score: filterRange[i] }]
        )
      );
      setFiltered(csiScore);
    }
    return () => setFiltered([]);
  }, [popup, colorAttributeFound, selected]);

  const handleThumbnail = (item) => {
    const getOriginal = colorAttributeFound
      .filter((thumb) => thumb[0].csi_code === item.csi_code)
      .map((item) => item[0]);
    handleClick(getOriginal[0], "thumbnail");
  };

  // useEffect(() => {
  //   if (popup) {
  //     const getTheCC = commonCrust.map((rgbVal) =>
  //       RGBToHSB(rgbVal.colorAtt[0], rgbVal.colorAtt[1], rgbVal.colorAtt[2])
  //     );

  //     const compareTo = RGBToHSB(
  //       selected.colorAtt[0],
  //       selected.colorAtt[1],
  //       selected.colorAtt[2]
  //     );

  //     const compareHSV = getTheCC.map((item) => [(item[0] + compareTo[0]) / 2]);

  //     console.log(compareHSV);
  //     const getClosestTo = commonCrust.map((bestColor) =>
  //       getDiff(bestColor, selected.colorAtt)
  //     );
  //     const idx = getClosestTo.indexOf(Math.min.apply(null, getClosestTo));
  //     setCrust(commonCrust[idx]);
  //   }
  // }, [popup]);

  if (popup) {
    return (
      <div className="csi-modal">
        <Dialog
          className="modal"
          maxWidth={"md"}
          open={popup}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          transitionDuration={{ enter: 10 }}
        >
          <div
            id="imageDIV"
            style={{
              height: `${trayHeight}px`,
              width: `${trayWidth}px`,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <div
              className="modal-swatch-color"
              style={{
                height: "78%",
                background: selected.hex,
                boxShadow: "0 0 5px black",
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {selected.crust && (
                <div
                  className="common-crust"
                  style={{ top: viewCrust ? "-40px" : "-170px" }}
                >
                  <img src={getCrust(selected.crust)} alt="crust" width="300" />
                  <div className="common-crust-title">
                    <h5
                      style={{
                        cursor: "pointer",
                        color: selected.isDark ? "white" : "black",
                      }}
                      onClick={() => setViewCrust(!viewCrust)}
                    >
                      {viewCrust ? "\u25B2" : "\u25BC"} Common Crust:
                      {selected.crust}
                    </h5>
                  </div>
                </div>
              )}
              {filtered.length >= 1 && (
                <div className="similar-color-tray">
                  {!dismissMessage && showFamily && dimensions.height >= 150 && (
                    <div className="similar-tray-message-box">
                      <div className="similar-tray-message">
                        <h5>Lot's of shades and not enough space!</h5>
                        <div className="similar-tray=message-buttons">
                          <button onClick={handleDismissMessage}>
                            Dismiss
                          </button>
                          <button onClick={handleSettings}>Settings</button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className="similar-color-toggle"
                    onClick={() => setShowFamily(!showFamily)}
                  >
                    <h6 style={{ color: selected.isDark ? "white" : "black" }}>
                      {showFamily ? (
                        <strong>
                          hide {colorAttributeFound.length - 1} shades &#9660;
                        </strong>
                      ) : (
                        <Tooltip
                          TransitionComponent={Fade}
                          TransitionProps={{ timeout: 200 }}
                          key="show-shades"
                          placement="top-start"
                          title={
                            showTip
                              ? "View other CSI's in the same color range"
                              : null
                          }
                        >
                          <strong>
                            show {colorAttributeFound.length - 1} shades &#9650;
                          </strong>
                        </Tooltip>
                      )}
                    </h6>
                  </div>

                  <div className="similar-colors-get-height" ref={targetRef}>
                    {showFamily && filtered && (
                      <div className="similar-colors">
                        {filtered
                          .filter(
                            (thumb) => thumb[0].csi_code !== selected.csi_code
                          )
                          .sort((a, b) => b[0].score - a[0].score)
                          .map((item) => (
                            <div key={item[0].csi_code}>
                              <Tooltip
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 200 }}
                                key={item[0].csi_code}
                                title={
                                  item[0].csi_code + " - " + item[0].csi_name
                                }
                              >
                                <div
                                  className="similar-color-thumb"
                                  onClick={() => handleThumbnail(item[0])}
                                  data-target={item[0].csi_code}
                                  style={{
                                    cursor: "pointer",
                                    width: `${similarColorThumb}px`,
                                    height: `${similarColorThumb}px`,
                                    padding: "4px",
                                    fontSize: "8px",
                                    color: `${
                                      selected.isDark
                                        ? "rgba(255,255,255,0.5)"
                                        : "rgba(0,0,0,0.5)"
                                    }`,
                                    background: item[0].hex,
                                    boxSizing: "border-box",
                                    boxShadow: `inset 0 0 4px ${selected.hex}`,
                                    filter: `drop-shadow(0 0 1px ${
                                      selected.isDark
                                        ? "rgba(100,100,100,0.2)"
                                        : "rgba(0,0,0,0.2)"
                                    })`,
                                  }}
                                >
                                  {/* {item[0].score} */}
                                  <span
                                    className="similar-thumb-triangle"
                                    style={{
                                      background: selected.isDark
                                        ? "rgba(0,0,0,0.1)"
                                        : "rgba(0,0,0,0.05)",
                                    }}
                                  ></span>
                                </div>
                              </Tooltip>
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div
                className="close-modal-icon"
                style={{
                  filter: `invert(${selected.isDark ? 1 : 0})`,
                }}
              >
                <span onClick={handleClose}>{closeModalIcon}</span>
              </div>
              {store.includes(selected.csi_code) ? (
                <div
                  className="store-button"
                  style={{
                    filter: `invert(${selected.isDark ? 1 : 0}) opacity(0.8)`,
                  }}
                  onClick={() => handleStore(selected.csi_code)}
                >
                  {starSolidIcon}
                </div>
              ) : (
                <Tooltip
                  TransitionComponent={Fade}
                  TransitionProps={{ timeout: 200 }}
                  placement="right-start"
                  key="show-save"
                  title={
                    showTip
                      ? `Save ${
                          selected.csi_code + " - " + selected.csi_name
                        } for later.`
                      : null
                  }
                >
                  <div
                    className="store-button"
                    style={{
                      filter: `invert(${selected.isDark ? 1 : 0}) opacity(0.8)`,
                    }}
                    onClick={() => handleStore(selected.csi_code)}
                  >
                    {starOutlineIcon}
                  </div>
                </Tooltip>
              )}
            </div>
            <div
              className="modal-middle-bar"
              style={{
                display: "flex",
                flexDirection: "column",
                fontSize: selected.csi_name.length <= 14 ? "24px" : "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
                justifyContent: "center",
                alignItems: "center",
                height: "15%",
                borderBottom: `thick solid ${selected.hex + "90"}`,
              }}
            >
              {selected.csi_code} - {selected.csi_name}
              <h5 style={{ opacity: "0.4" }}>{selected.hex}</h5>
            </div>

            {/* <h5 style={{textAlign:'center', borderTop: 'thin dashed lightgray'}}>Download</h5> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "32px",
                width: "100%",
                padding: "0 2px",
                boxSizing: "border-box",
                background: selected.hex + "30",
              }}
            >
              <Tooltip
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 200 }}
                placement="top"
                key="show-save-small"
                title={
                  showTip
                    ? `Download a small image of ${
                        selected.csi_code + " - " + selected.csi_name
                      }`
                    : null
                }
              >
                <button
                  className="download-button"
                  style={{
                    width: "50%",
                    height: 25,
                    textTransform: "uppercase",
                    opacity: "0.8",
                  }}
                  onClick={() => handleDownload("small", selected)}
                >
                  DOWNLOAD MINI SWATCH
                </button>
              </Tooltip>
              <span className="download-icon" style={{ stroke: selected.hex }}>
                {downloadIcon}
              </span>
              <Tooltip
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 200 }}
                placement="top"
                key="show-save-large"
                title={
                  showTip
                    ? `Download a slightly larger image of ${
                        selected.csi_code + " - " + selected.csi_name
                      }`
                    : null
                }
              >
                <button
                  className="download-button"
                  style={{
                    width: "50%",
                    height: 25,
                    textTransform: "uppercase",
                    opacity: "0.8",
                  }}
                  onClick={() => handleDownload("large", selected)}
                >
                  DOWNLOAD LARGE SWATCH
                </button>
              </Tooltip>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
  return null;
}

export default DialogModal;
